import { AfterViewInit, Component, EventEmitter, EnvironmentInjector, Input, OnInit, Output, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';

declare var bootstrap: any; // Bootstrap JS

export interface ModelConfig<T> {
  title?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  backdrop?: boolean | 'static';
  keyboard?: boolean;
  centered?: boolean;
  scrollable?: boolean;
  maxWidth?: string;
  minWidth?: string;
  maxHeight?: string;
  minHeight?: string;
  customClass?: string;
  data?: T;
  buttons?: [{
    label: string,
    action: (data?: any) => void,
    classes: string,
  }]
}

@Component({
  selector: 'app-dynamic-model',
  templateUrl: 'dynamic-model.component.html',
  styleUrls: ['./dynamic-model.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class DynamicModelComponent implements OnInit, AfterViewInit {
  private _config: ModelConfig<any> = {
    backdrop: true,
    keyboard: true,
  }

  @ViewChild('dynamicContent', { read: ViewContainerRef, static: false })
  contentRef!: ViewContainerRef;

  @Input() componentType!: Type<any>;
  @Input() set config(config: ModelConfig<any>) {
    this._config = { ...this._config, ...config };
  }
  @Input() modalId!: string;
  @Input() environmentInjector?: EnvironmentInjector;

  @Output() onClose = new EventEmitter<any>();

  private modalInstance: any;

  get config(): ModelConfig<any> {
    return this._config;
  }


  ngOnInit() {
    // Auto-open modal after it's attached
    setTimeout(() => {
      const modalEl = document.getElementById(this.modalId);
      this.modalInstance = new bootstrap.Modal(modalEl);
      this.modalInstance.show();
    });
  }

  ngAfterViewInit() {
    // Use the provided environmentInjector if available
    const compRef = this.environmentInjector
      ? this.contentRef.createComponent(this.componentType, { environmentInjector: this.environmentInjector })
      : this.contentRef.createComponent(this.componentType);
    Object.assign(compRef.instance, this.config.data);

    if (compRef.instance.closed instanceof EventEmitter) {
      compRef.instance.closed.subscribe((data: any) => {
        this.close(data);
      });
    }
  }

  close(data: any = null) {
    this.modalInstance.hide();
    this.onClose.emit(data);
  }
}
